<div class="reader-wrapper">
    <!-- HEADER -->
    <div class="reader-header">
        <a [routerLink]="['/charger-home']" style="display: flex;margin-right: 10px;">
            <svg
                width="16"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.292893 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538408 7.04738 0.538408 6.65685 0.928933L0.292893 7.29289ZM14 7L1 7L1 9L14 9L14 7Z"
                    fill="white"
                />
            </svg>
        </a>
        <span>EV Charging Sessions</span>
    </div>

    <!-- CONTENT -->
    <div class="content-wrapper">
        <div class="container">
            <table class="table">
                <thead>
                    <tr>
                        <th>Transaction ID</th>
                        <th>Charger ID</th>
                        <th>Station</th>
                        <th>Connector</th>
                        <th>Date</th>
                        <th>Start Time</th>
                        <th>Stop Time</th>
                        <th>Duration</th>
                        <th>Energy (kWh)</th>
                        <th>Amount (₹)</th>
                        <th>Payment</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of chargeHistory">
                        <td data-label="Transaction ID">
                            {{ item.transaction_id }}
                        </td>
                        <td data-label="Charger ID">{{ item.charger_id }}</td>
                        <td data-label="Station">{{ item.station_name }}</td>
                        <td data-label="Connector">{{ item.connector_no }}</td>
                        <td data-label="Date">{{ item.transaction_date }}</td>
                        <td data-label="Start Time">{{ item.start_time }}</td>
                        <td data-label="Stop Time">{{ item.stop_time }}</td>
                        <td data-label="Duration">
                            {{ convertToMinutes(item.duration) }}
                        </td>
                        <td data-label="Energy">{{ item.energy_consumed }}</td>
                        <td data-label="Amount">₹{{ item.payable_amount }}</td>
                        <td data-label="Payment">{{ item.payment_source }}</td>
                        <td data-label="Status">
                            <span
                                [ngClass]="{
                                    'text-success': item.status === 'Complete',
                                    'text-warning': item.status !== 'Complete'
                                }"
                            >
                                {{ item.status }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- FOOTER -->
    <footer class="web-footer">
        <a href="https://ezy-charge.com/about-us.php" target="_blank"
            >About Us</a
        >
        <a href="https://ezy-charge.com/contact.php" target="_blank"
            >Contact Us</a
        >
        <a href="https://ezy-charge.com/privacy-policy.php" target="_blank">
            Privacy Policy
        </a>
        <a
            href="https://ezy-charge.com/refund-cancellation-policy.php"
            target="_blank"
        >
            Refund Policy
        </a>
    </footer>
</div>
